<template>
  <div class="app-footer">
    <!-- Sprachumschalter: nur auf Mobile/Tablet – auf Desktop ist er in der Navigationsleiste oben rechts -->
    <div v-if="!display.isDesktop" class="app-footer__lang">
      <LanguageSwitcher />
    </div>

    <!-- Zentrierte rechtliche Links -->
    <div class="app-footer__links d-flex flex-column flex-md-row justify-center align-center ga-1 flex-wrap">
      <div class="mb-2 mb-md-0">
        <router-link :to="{ name: 'PagePrivacyPolicy' }" class="footer-link" target="_blank" rel="noopener noreferrer">
          {{ t("footer.privacy") }}
        </router-link>
      </div>

      <div class="mb-2 mb-md-0">
        <router-link :to="{ name: 'PageImprint' }" class="footer-link" target="_blank" rel="noopener noreferrer">
          {{ t("footer.imprint") }}
        </router-link>
      </div>

      <div class="mb-2 mb-md-0">
        <a href="https://www.kars-connection.de" target="_blank" class="footer-link" rel="noopener noreferrer">
          {{ t("footer.website") }}
        </a>
      </div>

      <div>
        <span class="footer-text">v{{ version }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { useDisplayStore } from "@/stores/displayStore";
import LanguageSwitcher from "@/components/app/LanguageSwitcher.vue";

export default {
  name: "Footer",
  components: { LanguageSwitcher },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  created() {
    this.display = useDisplayStore();
  },

  data() {
    return {
      version: __APP_VERSION__,
    };
  },
};
</script>

<style scoped>
.app-footer {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 20px 20px;
}

.app-footer__lang {
  flex: 0 0 auto;
}

.app-footer__links {
  flex: 1 1 auto;
}

.footer-link {
  text-decoration: none;
  font-size: 0.8rem;
  color: var(--grey-color);
  margin-left: 16px;
  margin-right: 16px;
}

.footer-link:hover {
  text-decoration: underline;
}

.footer-text {
  font-size: 0.8rem;
  color: var(--grey-color);
  margin-right: 4px;
}

/* Auf kleinen Bildschirmen Switcher über die zentrierten Links stapeln. */
@media (max-width: 600px) {
  .app-footer {
    flex-direction: column;
    gap: 12px;
  }
}
</style>
